/**
 * Per-product cart quantities for the POS product grid.
 *
 * Built once per cart change by the product list and handed to each tile as a
 * plain number. Previously every tile subscribed to CartContext and rescanned
 * the cart itself, so a single product tap re-rendered every mounted tile.
 */

/**
 * Sum cart line quantities by `itemId` (same arithmetic as the former per-tile
 * loop: `count += line.quantity` for every line whose itemId matches).
 *
 * @param {Array<{itemId?: string, quantity?: number}>} cartItems
 * @returns {Map<string, number>} itemId → total quantity.
 */
export const buildCartCountByItemId = (cartItems) => {
    const counts = new Map();

    if (!Array.isArray(cartItems)) {
        return counts;
    }

    for (let i = 0; i < cartItems.length; i++) {
        const line = cartItems[i];
        const itemId = line?.itemId;
        counts.set(itemId, (counts.has(itemId) ? counts.get(itemId) : 0) + line?.quantity);
    }

    return counts;
};

/**
 * Cart quantity for one product (0 when it is not in the cart).
 *
 * @param {Map<string, number>} counts Result of buildCartCountByItemId.
 * @param {string} foodId
 * @returns {number}
 */
export const getCartCount = (counts, foodId) => {
    return counts.has(foodId) ? counts.get(foodId) : 0;
};
